export default __webpack_public_path__ + "static/project-slide-4-2016-765-eadbe907ed864c2f72e73167ce39b98f.webp";